const ownedRequests = new WeakSet();
let pending = 0;
let cartRead = null;
let revision = 0;

function cartMutation(input, options) {
  const url = new URL(typeof input === "string" || input instanceof URL ? input : input.url, location.origin);
  const method = (options?.method || input?.method || "GET").toUpperCase();
  return url.origin === location.origin && method !== "GET" && /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname);
}

function notifyExternal(input, options) {
  revision += 1;
  document.dispatchEvent(new CustomEvent("cart:external-change", {
    detail: { added: /\/cart\/add(?:\.js)?(?:\?|$)/.test(typeof input === "string" || input instanceof URL ? String(input) : input.url) },
  }));
}

const originalFetch = window.fetch;
window.fetch = function (input, options) {
  const observe = !ownedRequests.has(options) && cartMutation(input, options);
  const result = originalFetch.call(this, input, options);
  if (observe) {
    result.then((response) => {
      if (response.ok) notifyExternal(input, options);
    }, () => {});
  }
  return result;
};

const xhrOpen = XMLHttpRequest.prototype.open;
const xhrSend = XMLHttpRequest.prototype.send;
const xhrRequests = new WeakMap();
XMLHttpRequest.prototype.open = function (method, url, ...args) {
  xhrRequests.set(this, { url: String(url), method });
  return xhrOpen.call(this, method, url, ...args);
};
XMLHttpRequest.prototype.send = function (...args) {
  const request = xhrRequests.get(this);
  if (request && cartMutation(request.url, request)) {
    this.addEventListener("loadend", () => {
      if (this.status >= 200 && this.status < 300) notifyExternal(request.url, request);
    }, { once: true });
  }
  return xhrSend.apply(this, args);
};

export const cartRuntime = {
  get busy() { return pending > 0; },
  begin() {
    pending += 1;
    document.dispatchEvent(new CustomEvent("cart:busy", { detail: { busy: true } }));
    let released = false;
    return () => {
      if (released) return;
      released = true;
      pending -= 1;
      document.dispatchEvent(new CustomEvent("cart:busy", { detail: { busy: pending > 0 } }));
    };
  },
  request(input, options = {}) {
    ownedRequests.add(options);
    if (cartMutation(input, options)) revision += 1;
    return window.fetch(input, options);
  },
  read() {
    if (cartRead?.revision === revision) return cartRead.promise;
    const entry = { revision };
    entry.promise = this.request(`${Shopify.routes.root}cart.js`)
      .then(async (response) => {
        if (!response.ok) throw new Error("Unable to read cart");
        return response.json();
      }).finally(() => {
        if (cartRead === entry) cartRead = null;
      });
    cartRead = entry;
    return entry.promise;
  },
};
window.GlowidCart = cartRuntime;
